import React, { useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ModalContext } from 'App';
import { numberWithCommas } from 'helper';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import Pagination from 'modules/common/components/Pagination';
import useDebounce from 'modules/common/components/UseDebounce';
import CreateModal from '../modals/CreateModal';
import UpdateModal from '../modals/UpdateModal';
import * as actions from '../actions';
import * as c from '../constant';
import ViewModal from '../modals/ViewModal';
import TransferModal from '../modals/TransferModal';

const filterDefault = {
  q: '',
};

function TaxCreditContainer({
  getList,
  dataList,
  dataListPager,
  isLoading,
  history,
  removeData,
}) {
  const [filter, setFilter] = useState(filterDefault);
  const [pagination, setPagination] = useState({
    per_page: 15,
    page: 1,
  });
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFilter({
      ...filter,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangePage = (page) => {
    setPagination({ ...pagination, page });
    getList({ ...pagination, page });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Tax Credit',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal dataList={data} id={data.id} />,
      title: 'Update Tax Credit',
      modalSize: 'modal-md',
    });
  };

  const handleViewModal = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <ViewModal dataList={data} id={data.id} handleEdit={handleEdit} />
      ),
      title: 'View',
      modalSize: 'modal-xl',
    });
  };

  const handleTransfer = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <TransferModal id={data.id} />,
      title: 'Transfer Tax Credit',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (id) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this item?',
      () => {
        removeData(id, {}, () => {
          getList({}, () => {
            history.push('/rpt/machinery/machinery-settings/tax-credit');
          });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(filter, 500);

  useEffect(() => {
    if (debouncedSearchTerm) {
      getList(
        _.omitBy(
          {
            ...filter,
            sort_by: 'asc',
          },
          _.isEmpty
        )
      );
    } else {
      setFilter({});
      history.replace({ pathname: window.location.pathname });
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="mr-5 mt-5 shadow card-content-listing bg-white rounded mh-100">
      <div className="d-flex pr-5 pb-4">
        <div className="list-name">Tax Credit</div>
        <div className="my-auto ml-auto">
          {/* {Acl(permissions, ['E2E RPT BUILDING ADD TAX CREDIT']) && ( */}
          <button
            type="button"
            onClick={handleAddModal}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold px-4 ml-auto"
          >
            <i className="fas fa-plus" />
            &nbsp; Add Tax Credit
          </button>
          {/* )} */}
        </div>
      </div>
      <div className="pr-5">
        <div className="d-flex flex-column pl-4 pb-4">
          <div className="col-12 form-wrapper d-flex align-items-center search-container">
            <span className="icon">
              <i className="fa fa-lg fa-search" />
            </span>
            <input
              className="search-input w-100"
              type="text"
              name="q"
              id="q"
              placeholder="Search..."
              onChange={handleOnChange}
              value={_.get(filter, 'q') || ''}
              maxLength={50}
            />
          </div>
        </div>
      </div>
      {isLoading ? (
        <div
          className="loading d-flex text-center justify-content-center align-items-center"
          style={{ height: '500px' }}
        >
          <div className="spinner text-center ">
            <span className="fas fa-5x fa-spin fa-spinner" />
          </div>
        </div>
      ) : (
        <div className="pl-4 pr-5">
          <table className="table table-striped table-sm">
            <thead className="table-header">
              <tr className="bg-primary-light">
                <td className="h3 pl-3" width="500">
                  PIN
                </td>
                <td className="h3" width="500">
                  TDN
                </td>
                <td className="h3" width="500">
                  Amount
                </td>
                <td />
              </tr>
            </thead>
            <tbody className="table-details text-dark">
              {dataList.length !== 0 ? (
                dataList.map((item) => {
                  return (
                    <tr key={item.id}>
                      <td className="pl-3 justify-center">
                        {_.get(item, 'attributes.machinery_application_pin') ||
                          '---'}
                      </td>
                      <td>
                        {_.get(item, 'attributes.machinery_application_tdn') ||
                          '---'}
                      </td>
                      <td>
                        <span className="font-weight-bold">PHP </span>
                        {numberWithCommas(_.get(item, 'attributes.amount')) ||
                          '---'}
                      </td>
                      <td>
                        <div className="d-flex justify-content-end">
                          {/* {Acl(permissions, [
                            'E2E RPT LAND VIEW TAX CREDIT',
                          ]) && ( */}
                          <button
                            type="button"
                            className="btn-blank"
                            onClick={handleViewModal({
                              id: _.get(item, 'id'),
                              name: _.get(item, 'attributes.name'),
                              admin_module_id: _.get(
                                item,
                                'attributes.admin_module_id'
                              ),
                            })}
                          >
                            <i className="far fa-eye icon-plain-square shadow-sm" />
                          </button>
                          {/* )} */}
                          {/* {Acl(permissions, [
                            'E2E RPT BUILDING EDIT TAX CREDIT',
                          ]) && ( */}
                          <button
                            type="button"
                            className="btn-blank"
                            onClick={handleEdit({
                              id: _.get(item, 'id'),
                              name: _.get(item, 'attributes.name'),
                              admin_module_id: _.get(
                                item,
                                'attributes.admin_module_id'
                              ),
                            })}
                          >
                            <i className="fas fa-edit icon-plain-square shadow-sm" />
                          </button>
                          {/* )} */}
                          {/* {Acl(permissions, [
                            'E2E RPT BUILDING TRANSFER TAX CREDIT',
                          ]) && ( */}
                          <button
                            type="button"
                            className="btn-blank"
                            onClick={handleTransfer({
                              id: _.get(item, 'id'),
                              name: _.get(item, 'attributes.name'),
                              admin_module_id: _.get(
                                item,
                                'attributes.admin_module_id'
                              ),
                            })}
                          >
                            <i className="fa fa-external-link-alt icon-plain-square shadow-sm" />
                          </button>
                          {/* )} */}
                          {/* {Acl(permissions, [
                            'E2E RPT BUILDING DELETE TAX CREDIT',
                          ]) && ( */}
                          <button
                            type="button"
                            className="btn-blank"
                            onClick={handleRemove(_.get(item, 'id'))}
                          >
                            <i className="far fa-trash-alt icon-delete-square shadow-sm" />
                          </button>
                          {/* )} */}
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={4} className="text-center">
                    No Results Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      <div className="list-pagination">
        {dataListPager.total_pages > 1 ? (
          <div className="d-flex justify-content-center text-center align-item-center">
            <Pagination data={dataListPager} onChange={handleChangePage} />
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}

TaxCreditContainer.propTypes = {
  history: PropTypes.instanceOf(Object).isRequired,
  getList: PropTypes.instanceOf(Function).isRequired,
  dataList: PropTypes.instanceOf(Array).isRequired,
  removeData: PropTypes.instanceOf(Function).isRequired,
  dataListPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  dataList: _.get(api, `${c.GET_LIST}.list`) || [],
  dataListPager: _.get(api, `${c.GET_LIST}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_LIST) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TaxCreditContainer);
